var _style, _circle, _circle2, _circle3, _path, _rect, _circle4, _circle5, _circle6, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtReset({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: "100%",
    height: "100%",
    role: "img",
    "aria-label": "Animated password reset illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .shackle {\n      transform-box: fill-box;\n      animation: shut 5s cubic-bezier(0.34, 1.2, 0.4, 1) infinite;\n    }\n    @keyframes shut {\n      0%, 26%   { transform: translateY(-13px); }\n      44%, 76%  { transform: translateY(0); }\n      92%, 100% { transform: translateY(-13px); }\n    }\n\n    .dot {\n      transform-box: fill-box;\n      transform-origin: 50% 50%;\n      animation: type 5s cubic-bezier(0.34, 1.4, 0.45, 1) infinite;\n    }\n    .d-1 { animation-delay: 0s; }\n    .d-2 { animation-delay: 0.14s; }\n    .d-3 { animation-delay: 0.28s; }\n    @keyframes type {\n      0%, 2%    { transform: scale(0); }\n      14%, 78%  { transform: scale(1); }\n      90%, 100% { transform: scale(0); }\n    }\n\n    .seal {\n      fill: none; stroke: #19b87a; stroke-width: 3.5; stroke-linecap: round;\n      stroke-dasharray: 290;\n      animation: seal 5s ease-in-out infinite;\n    }\n    @keyframes seal {\n      0%, 46%   { stroke-dashoffset: 290; }\n      68%, 80%  { stroke-dashoffset: 0; }\n      90%, 100% { stroke-dashoffset: 290; }\n    }\n\n    .mote { animation: drift 6s ease-in-out infinite; }\n    .mote-2 { animation-duration: 7.5s; animation-delay: -2s; }\n    .mote-3 { animation-duration: 8.5s; animation-delay: -4s; }\n    @keyframes drift {\n      0%, 100% { transform: translateY(0); opacity: 0.55; }\n      50%      { transform: translateY(-7px); opacity: 1; }\n    }\n\n    @media (prefers-reduced-motion: reduce) {\n      .shackle, .dot, .seal, .mote { animation: none; }\n      .shackle { transform: translateY(0); }\n      .dot { transform: scale(1); }\n      .seal { stroke-dashoffset: 0; }\n    }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mote",
    cx: 24,
    cy: 54,
    r: 3.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-2",
    cx: 176,
    cy: 48,
    r: 4.5,
    fill: "#ffffff",
    opacity: 0.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "mote mote-3",
    cx: 168,
    cy: 168,
    r: 3,
    fill: "#ffffff",
    opacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "shackle",
    d: "M74 100 v-14 a26 26 0 0 1 52 0 v14",
    fill: "none",
    stroke: "#cfe0f0",
    strokeWidth: 11,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 98,
    width: 88,
    height: 66,
    rx: 18,
    fill: "#ffffff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "dot d-1",
    cx: 78,
    cy: 131,
    r: 7,
    fill: "#2b8fe0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "dot d-2",
    cx: 100,
    cy: 131,
    r: 7,
    fill: "#2b8fe0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "dot d-3",
    cx: 122,
    cy: 131,
    r: 7,
    fill: "#2b8fe0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "seal",
    x: 56,
    y: 98,
    width: 88,
    height: 66,
    rx: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtReset);
export default __webpack_public_path__ + "static/media/art-reset.91b52cda908c9e88e031b876e649383e.svg";
export { ForwardRef as ReactComponent };